import { BodyText, Button, FlexRow, Grid, ModalWindow, SpruceHelpInlineLink } from 'ui-toolkit';
import { convertToError } from '../../../API/BaseApi';
import React, { useState } from 'react';

export interface IFeesErrorModalProps {
  error: any;
  onClose?: () => void;
  title: string;
  reset?: () => void;
}

export const FeesErrorModal: React.FC<IFeesErrorModalProps> = ({ onClose, error, title, reset }) => {
  const [showModal, setShowModal] = useState(true);
  const onClick = () => {
    if (onClose) {
      onClose();
    }
    if (reset) {
      reset();
    }
    setShowModal(false);
  };
  return (
    <>
      {showModal && (
        <ModalWindow mode={'transition'} title={title}>
          <Grid>
            <BodyText>{convertToError(error)?.message}</BodyText>
            <BodyText>
              Please reload the page or <SpruceHelpInlineLink /> to submit a request for help
            </BodyText>
            <FlexRow justifyContent={'center'}>
              <Button intent={'danger'} onClick={onClick}>
                Close
              </Button>
            </FlexRow>
          </Grid>
        </ModalWindow>
      )}
    </>
  );
};
